import { Fragment, useState } from 'react';
import { useAsync } from 'react-async';
import {
  approvePendingTherapistChanges,
  getPendingTherapists, rejectPendingTherapistChanges
} from '../../../api/services/therapistService';
import Layout from '../../../components/layout';
import { Notification } from '../../../components/notifications';
import LayoutError from '../../../components/layoutError';
import DataTable from '../../../components/dataTable';
import EditModal from '../../../components/editModal';
import { useHistory } from 'react-router-dom';
import User from '../../../api/models/user';
import moment from 'moment';
import { getStates } from '../../../api/services/stateService';
import State from '../../../api/models/state';
import { Role, TimesheetUnlockStatusLookup } from '../../../common/constants';
import { useAppSelector } from '../../../app/hooks';
import { approvePendingBonus, rejectPendingBonus } from '../../../api/services/bonusServices';
import Bonus from '../../../api/models/bonus';
import payrate from '../../../api/models/payrate';
import { selectOption } from '../../../types/selectOption';
import { hasRole } from '../../../common/utils';
import { getTimesheetUnlockRequests, setTimesheetUnlockRequestStatus } from '../../../api/services/timesheetUnlockService';
import TimesheetUnlockRequestData from '../../../api/requests/timesheetUnlockRequestData';
import TimesheetUnlockRequestModel from '../../../api/models/timesheetUnlockRequestModel';
import SetTimesheetUnlockRequestStatusData from '../../../api/requests/setTimesheetUnlockRequestStatusData';

const UnlockTimesheets = () => {
  const history = useHistory();
  const [requests, setRequests] = useState<TimesheetUnlockRequestModel[]>();
  const [message, setMessage] = useState<string>('');
  const [error, setError] = useState<string>('');
  const [openRejectConfirmModal, setOpenRejectConfirmModal] = useState<boolean>(false);
  const [timehseetUnlockRequestId, setTimesheetUnlockRequestId] = useState<number | null>();

  const { isPending } = useAsync({
    promiseFn: getTimesheetUnlockRequests,
    onResolve: (r) => setRequests(r.data)
  });

  const columns = () => [
    {
      Header: 'Therapist Name',
      accessor: (s: any) => s.therapistName
    },
    {
      Header: 'Discipline',
      accessor: (s: any) => s.disciplineName
    },
    {
      Header: 'Period',
      accessor: (s: any) => s.period
    },
    {
      Header: 'Actions',
      accessor: (s: any) => (
        <>
          <button
            className='mr-3 primary'
            onClick={(e) => {
              approve.run(s.timesheetUnlockRequestId);
              e.stopPropagation();
            }}
          >
            Approve
          </button>
          <button
            className="bg-red-600 hover:bg-red-700"
            onClick={(e) => {
              setTimesheetUnlockRequestId(s.timesheetUnlockRequestId);
              setOpenRejectConfirmModal(true);
              e.stopPropagation();
            }}
          >
            Reject
          </button>
        </>
      ),
      disableSortBy: true,
      sortable: false,

    },
    {
      accessor: 'timehseetId',
      className: 'hidden',
    },
    {
      accessor: 'therapistId',
      className: 'hidden',
    },
  ];

  /**
   * Therapist change approval logic
   */
  const sendApprove = async (args: any) => {
    if (!args[0])
      setError("Timesheet unlock request is not selected");

    const data: SetTimesheetUnlockRequestStatusData = {
      status: TimesheetUnlockStatusLookup.Accepted,
      timesheetUnlockRequestId: args[0]
    }

    return await setTimesheetUnlockRequestStatus(data);
  }

  const approve = useAsync({
    deferFn: sendApprove,
    onResolve: (response: any) => {
      console.log(response)
      setRequests(response.data);
      setMessage('Timesheet unlock request successfully approved');
    },
    onReject: (data) => { console.log(data) }
  });

  const sendReject = async (args: any) => {
    if (!args[0])
      setError("Timesheet unlock request is not selected");

    const data: SetTimesheetUnlockRequestStatusData = {
      status: TimesheetUnlockStatusLookup.Rejected,
      timesheetUnlockRequestId: args[0]
    }

    return await setTimesheetUnlockRequestStatus(data);
  }

  const reject = useAsync({
    deferFn: sendReject,
    onResolve: (response: any) => {
      console.log(response)
      setRequests(response.data);
      setMessage('Timesheet unlock request successfully approved');
      setMessage('');
      setError('');
      setOpenRejectConfirmModal(false);
    },
    onReject: (data) => {
      setOpenRejectConfirmModal(false);
      setError('');
      setMessage('');
    }
  });

  if (error) return <LayoutError />;

  return (
    <Layout isLoading={
      isPending ||
      approve.isPending ||
      reject.isPending
    }>
      <Fragment>
        {message !== '' && <Notification>{message}</Notification>}
        {error !== '' && <Notification>{error}</Notification>}
        {/** Rejection confirmation modal */}
        <EditModal
          open={openRejectConfirmModal}
          saveText='Confirm'
          onSave={() => { reject.run(timehseetUnlockRequestId); }}
          onCancel={() => { setOpenRejectConfirmModal(false) }}
          id={timehseetUnlockRequestId!}
        ><h3>Are you sure you would like to reject the requested timesheet unlock for this therapist?</h3>
        </EditModal>

        <div className='grid grid-cols-5 gap-5 mb-6'>
          <div className='col-span-5 sm:col-span-5'>
            <div className='overflow-hidden border-b border-gray-200 rounded-lg therapistsApprove datatable-editable'>
              {requests && requests.length > 0 && (
                <DataTable
                  key={'pc-datatable'}
                  columns={columns()}
                  data={requests}
                  showPagination={true}
                  getRowProps={(row: any) => ({
                    className: "cursor-pointer hover:bg-gray-100",
                    onClick: () => history.push(`/admin/therapists/${row.values.userId}`)
                  })}
                />
              )}
              {(requests?.length === 0 || requests === undefined) && <h3>No pending timesheet unlock requests were found</h3>}
            </div>
          </div>
        </div>
      </Fragment>
    </Layout>
  );
};

export default UnlockTimesheets;